import { v4 as uuidV4 } from 'uuid';

export default function prepareFilename(filename) {
  const dotPlusExtension = filename.substr(filename.lastIndexOf('.'));

  return `${uuidV4()}${dotPlusExtension}`;
}
